import { timeParse } from 'd3-time-format';
import { dataConfig, partyKeys, partyStartDates } from '$lib/constants/crosswalk';

const parseDate = timeParse('%Y-%m-%d');

/**
 * Display-name overrides for `media_outlet_en` values the data still exports
 * under an older name.
 */
export const mediaOutletOverrides: Record<string, string> = {
  'Galei Tzahal': 'Army Radio',
};

/**
 * One raw poll record has a column per party; this fans it out into one row
 * per party per poll (skipping parties that record didn't ask about, i.e.
 * value is null), keyed generically off `dataConfig`/`partyKeys` so it works
 * for any dataset shaped the same way.
 */
const toRows = (record: Record<string, unknown>) => {
  const rawDate = record[dataConfig.dateField] as string;
  const date = parseDate(rawDate);
  const pollster = record[dataConfig.pollsterField];
  const rawMediaOutlet = record[dataConfig.mediaOutletField] as string;
  const mediaOutlet = mediaOutletOverrides[rawMediaOutlet] ?? rawMediaOutlet;
  const respondents = record[dataConfig.respondentsField];
  const sourceUrl = record[dataConfig.sourceUrlField];
  const auditFlags = record[dataConfig.auditFlagsField] || [];

  return partyKeys
    .filter((key) => record[key] !== null && record[key] !== undefined)
    .filter((key) => !partyStartDates[key] || rawDate >= partyStartDates[key])
    .map((key) => ({
      party: key,
      date,
      value: record[key] as number,
      respondents,
      pollster,
      mediaOutlet,
      sourceUrl,
      auditFlags,
    }));
};

export const parseAll = (records: Record<string, unknown>[]) =>
  records.flatMap(toRows);
